function getDifferenceFromPast(msgTime) {
   const currentTime = Date.now();
   const diffMilliseconds = msgTime - currentTime;
   // const diffMinutes = Math.floor(diffMilliseconds / 60000); // 60000 milliseconds = 1 minute
   const diffSecs = Math.floor(diffMilliseconds / 1000);
   return diffSecs;
}

exports.getDifferenceFromPast = getDifferenceFromPast;
